import PropTypes from "prop-types";
import LevfinJuniorBankerMyDeals from "./levfin-junior-banker-mydeals/levfin-junior-banker-mydeals";
import { DashboardGridSkeleton } from "../../dashboard-skeletons/dashboard-skeletons";
import LevfinDealTracker from "../levfin-deal-tracker/levfin-deal-tracker";

const LevfinJuniorBanker = (props) => {
    return (
        <div>
            {
                props.isLevfinBankerTimeLogLoading ?
                    <DashboardGridSkeleton width="95vw" />
                    : props.levfinJuniorBankerTimeLogItems &&
                    <LevfinJuniorBankerMyDeals items={props.levfinJuniorBankerTimeLogItems} />
            }
            {
                props.isLevfinDealTrackerLoading ?
                    <DashboardGridSkeleton width="95vw" />
                    : props.levfinDealTrackerItems &&
                    <LevfinDealTracker items={props.levfinDealTrackerItems} />
            }
        </div>
    );
};

LevfinJuniorBanker.propTypes = {
  isLevfinBankerTimeLogLoading: PropTypes.bool.isRequired,
  levfinJuniorBankerTimeLogItems: PropTypes.object,
  isLevfinDealTrackerLoading: PropTypes.bool.isRequired,
  levfinDealTrackerItems: PropTypes.object,
};

export default LevfinJuniorBanker;